import React from "react";
import FieldElement from "./FieldElement";
import { SCALE } from "./constants";

/**
 * Canvas — either the live PDF preview iframe, or the interactive
 * drag-and-drop layout area with grid overlay + FieldElement children.
 */
export default function LayoutCanvas({
  previewMode,
  previewUrl,
  canvasW,
  canvasH,
  gridStep,
  pageCfg,
  pageDim,
  layoutEntries,
  selectedId,
  setSelectedId,
  updateField,
  onDragStart,
  onDragEnd,
  sampleMap,
}) {
  return (
    <div className="border border-border bg-card p-3">
      <div className="overline mb-2 flex justify-between">
        <span>
          Preview {pageCfg.size} {pageCfg.orientation} · {pageDim.w.toFixed(0)} × {pageDim.h.toFixed(0)} pt
        </span>
        <span className="font-mono">Scale {SCALE}x</span>
      </div>
      {previewMode ? (
        <iframe
          src={previewUrl}
          title="Live PDF Preview"
          className="w-full bg-white border border-border"
          style={{ height: canvasH + 20 + "px" }}
          data-testid="live-pdf-preview"
        />
      ) : (
        <div
          className="relative bg-white border border-border mx-auto shadow-md"
          style={{ width: canvasW, height: canvasH }}
          onClick={(e) => {
            // Only deselect when the user clicked the empty canvas itself.
            // Bubbled clicks from FieldElement children must not wipe selection.
            if (e.target === e.currentTarget) setSelectedId(null);
          }}
          data-testid="layout-canvas"
        >
          {/* Grid overlay - matches snap step */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage:
                gridStep > 0
                  ? "linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px)"
                  : "none",
              backgroundSize: gridStep > 0 ? `${gridStep * SCALE}px ${gridStep * SCALE}px` : "0",
              pointerEvents: "none",
            }}
          />
          {layoutEntries.map(([id, cfg]) => (
            <FieldElement
              key={id}
              id={id}
              cfg={cfg}
              selected={selectedId === id}
              onSelect={setSelectedId}
              onDrag={updateField}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              sample={sampleMap[id]}
              gridStep={gridStep}
              pageH={pageDim.h}
            />
          ))}
        </div>
      )}
    </div>
  );
}
